module.exports = __webpack_public_path__ + "static/img/modeling2.822c7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling2.png
// module id = 9gMs
// module chunks = 2